import ImageUploadPattern from 'assets/images/ImageUploadPattern.png';

import { memo, forwardRef, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useToggle from 'hooks/useToggle';
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import { Button } from 'components/Buttons';
import MediaDialog from 'dialogs/Media.dialog';

type Props = {
  className?: string;
  label?: string;
  value: string;
  onChange: (imageUrl:string) => void;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  errorText?: string;
  helperText?: string;
  width: number;
  height: number;
  format: MediaFormats;
}

const ImageUpload = forwardRef<any, Props>(({
  // Props
  className = '',
  label = '', value, onChange, required = false, disabled = false,
  error = false, errorText = '', helperText = '',
  width, height, format, ...otherProps
}, ref) => {
  const { t } = useTranslation('common');

  const handleClickClear = () => {
    onChange('');
  }

  const paddingTop = height/width * 100;
  const isClearButtonDisabled = !Boolean(value);

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      {open ? (
        <MediaDialog open={open} onClose={toggle} type="image" onChange={onChange} initialFormat={format} />
      ) : null}

      <div className="mb-4">
        <input ref={ref} type="hidden" name={(otherProps as any).name} />

        <div className={className}>
          {label ? (
            <span className={`block text-white text-sm font-semibold mb-1 ${disabled ? 'opacity-50' : ''}`}>
              {t(label)}{required ? <Fragment>&nbsp;*</Fragment> : null}
            </span>
          ) : null}
          <div
            className="relative rounded overflow-hidden w-full mb-4"
            style={{
              backgroundImage: `url(${ImageUploadPattern})`,
              boxShadow: 'inset 0 0 16px rgba(0,0,0,0.75)',
              paddingTop: `${paddingTop}%`
            }}
          >
            {value && (
              <img
                className="absolute top-0 left-0 w-full h-full object-contain"
                src={value}
                alt=""
              />
            )}
          </div>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outlined"
            disabled={disabled}
            onClick={toggle}
          >{t('common.browse')}</Button>
          <Button
            variant="outlined"
            disabled={disabled || isClearButtonDisabled}
            onClick={handleClickClear}
          >{t('common.clear')}</Button>
        </div>
        {helperText && helperText ? <span className="block text-gray-400 text-sm font-light leading-5 mt-2">{t(helperText)}</span> : null}
        {error && errorText ? <span className="block text-red-500 text-sm py-1 px-4">{t(errorText)}</span> : null}
      </div>
    </Fragment>
  )
});

export default memo(ImageUpload, (prev, next) => {
  return prev.value === next.value && prev.error === next.error && prev.disabled === next.disabled
});
